import { useState } from "react";
import "./OnboardingInfo.css";
import axios from "axios";
import { useNavigate } from "react-router";

interface ErrorType {
  firstName?: string;
  lastName?: string;
  email?: string;
}

const OnboardingInfoScreen = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");

  const [errors, setErrors] = useState<ErrorType>({});

  const navigate = useNavigate();

  const validate = () => {
    const newErrors: ErrorType = {};

    if (!firstName.trim()) {
      newErrors.firstName = "First name is required";
    }

    if (!lastName.trim()) {
      newErrors.lastName = "Last name is required";
    }

    if (!email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = "Invalid email format";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handlePress = async () => {
    if (!validate()) return;

    console.log("Form Submitted ✅");
    console.log("First Name:", firstName);
    console.log("Last Name:", lastName);
    console.log("Email:", email);
    // Call API here if needed

    const token = localStorage.getItem("accessToken");
    const userid = localStorage.getItem("id");
    console.log("token", token, userid);
    console.log(`${process.env.React_App_DYO_CHEF_Registration_URL}${userid}`);
    try {
      const response = await axios.put(
        `${process.env.React_App_DYO_CHEF_Registration_URL}${userid}`,
        { firstName, lastName, email },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response);
      if (response.status === 200) {
        console.log("all good");
        localStorage.setItem("FirstName", firstName);
        localStorage.setItem("LastName", lastName);
        localStorage.setItem("email", email);
        navigate("/");
      } else if (response.status === 401) {
        navigate("/login");
      } else {
        console.log("something went wrong");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="onboard-wrapper">
      <div className="onboard-container">
        <h2>
          Welcome to <span>Dyo Chef</span>
        </h2>
        <div className="onboard-form">
          <label className="form-label">First Name</label>
          <input
            type="text"
            className="form-input"
            placeholder="Enter your first name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
          {errors.firstName && (
            <span className="error-text">{errors.firstName}</span>
          )}

          <label className="form-label">Last Name</label>
          <input
            type="text"
            className="form-input"
            placeholder="Enter your last name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
          {errors.lastName && (
            <span className="error-text">{errors.lastName}</span>
          )}

          <label className="form-label">Email Address</label>
          <input
            type="email"
            className="form-input"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {errors.email && <span className="error-text">{errors.email}</span>}

          <button className="form-button" onClick={handlePress}>
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default OnboardingInfoScreen;
